import { render } from "./FragmentPropsCmp.vue?vue&type=template&id=2312a46a"
import script from "./FragmentPropsCmp.vue?vue&type=script&lang=js"
export * from "./FragmentPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__